import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { IconButton } from "@mui/material"
import { PeopleAltOutlined } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"
import { getShortResourceType } from "modules/resources/helpers"

export default function PermissionsButton({ account, title, alias, resourceType, disabled, defaultTab }) {
  return <Tooltip title={title}>
    <div>
      <IconButton
        disabled={disabled}
        component={Link}
        to={`/${account}/${getShortResourceType(resourceType)}/${alias}/permissions/${defaultTab}`}
        size="large"
      >
        <PeopleAltOutlined />
      </IconButton>
    </div>
  </Tooltip>
}

PermissionsButton.propTypes = {
  account: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  alias: PropTypes.string.isRequired,
  resourceType: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  defaultTab: PropTypes.string.isRequired,
}
